import { render, staticRenderFns } from "./SidebarBranch.vue?vue&type=template&id=5c3795b0&scoped=true"
import script from "./SidebarBranch.vue?vue&type=script&lang=js"
export * from "./SidebarBranch.vue?vue&type=script&lang=js"
import style0 from "./SidebarBranch.vue?vue&type=style&index=0&id=5c3795b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3795b0",
  null
  
)

export default component.exports